import React from 'react';

export const PipedriveSearchResultIcon = () => (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M16.2504 16.3271C16.2504 19.1676 17.6914 22.2318 20.8624 22.2318C23.2141 22.2318 25.5918 20.3959 25.5918 16.2854C25.5918 12.6815 23.7226 10.2621 20.9406 10.2621C18.6737 10.2621 16.2504 11.8546 16.2504 16.3271ZM22.0578 5C27.7435 5 31.5666 9.50318 31.5666 16.2064C31.5666 22.8043 27.5392 27.4106 21.7818 27.4106C19.0367 27.4106 17.2784 26.2349 16.359 25.3839C16.3656 25.5857 16.3699 25.8116 16.3699 26.0529V35H10.4799V11.1614C10.4799 10.8149 10.369 10.7052 10.0256 10.7052H8V5.48476H12.9424C15.218 5.48476 15.8005 6.6429 15.9113 7.53564C16.835 6.50033 18.7498 5 22.0578 5Z"
			fill="#017737"
		/>
	</svg>
);
